module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTczMCA0MzkuOGwtMTk0LjMgMTk0LjJhMzIgMzIgMCAwIDEtNDUuMyAwbC0xOTQuMi0xOTQuMmEzMiAzMiAwIDAgMSAyMi42LTU0LjZoMzg4LjZhMzIgMzIgMCAwIDEgMjIuNiA1NC42eiIgZmlsbD0iIzAiIHAtaWQ9IjMzMzciPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Caret down-filled.svg
// module id = yN6w
// module chunks = 75